module.exports = __webpack_public_path__ + "img/Character_Fischl_Thumb.551fefaa.png";